import pluginPkg from '../../package.json';

const pluginId: string = pluginPkg.name;

export default pluginId;
